export default __webpack_public_path__ + "static/media/getbiz@2x.82f29276.png";